import { energyPassportQuarterTableHeaders } from "@/features/energy-passport/ui/main-table/model/header.ts"
import { isITableHeaderLocale } from "@/shared/components/common/table/index.tsx"
import { cn } from "@/shared/lib/utils.ts"

const thProps = { className: "!h-[32px] !py-0 text-sm" }
const headers = energyPassportQuarterTableHeaders

export function TableChildRowsHeader() {
  return (
    <thead className="sticky top-0 z-40">
      {headers.map((row, rowIndex) => (
        <tr key={rowIndex}>
          {Array.isArray(row) ? (
            row.map((header, index) => (
              <th
                key={index}
                rowSpan={header.rowSpan}
                colSpan={header.colSpan}
                style={header.style}
                {...thProps}
                className={cn(header.className, thProps?.className)}
              >
                {isITableHeaderLocale(header) ? header.labelLocale : header.label}
              </th>
            ))
          ) : (
            <th key={rowIndex}>-</th>
          )}
        </tr>
      ))}
    </thead>
  )
}
